import AlertDanger from './alert-danger'

export default AlertDanger
